/**
 * Player API (BEWOTEC) SOAP client
 *
 * Singleton SOAP client configured for BEWOTEC Player API with retry support.
 *
 * @example
 * import { playerClient } from './playerClient';
 *
 * const response = await playerClient.call({
 *   action: 'GetProductList',
 *   body: xmlRequest,
 * });
 */

import axiosRetry from 'axios-retry';
import { SoapClient } from '../shared/soapClient';
import { PLAYER_API_CONFIG } from '@/constants/player/config';

/**
 * Player API (BEWOTEC) SOAP client
 *
 * Singleton instance with automatic retry support configured for BEWOTEC Player API.
 * Uses axios-retry with exponential backoff for transparent retry handling.
 * Communicates with the API gateway (dev: vamos-api.asiososys.com, prod: api.vamos-reisen.de),
 * which does not require authentication. See PLAYER_API_CONFIG.ENDPOINT.
 */
export const playerClient = new SoapClient({
  endpoint: PLAYER_API_CONFIG.ENDPOINT,
  namespace: PLAYER_API_CONFIG.NAMESPACE,
  timeout: PLAYER_API_CONFIG.TIMEOUT,
  retryConfig: {
    retries: PLAYER_API_CONFIG.RETRY.MAX_ATTEMPTS,
    retryDelay: axiosRetry.exponentialDelay, // Built-in exponential backoff
  },
});
